var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgControlPanelIconHovered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4168 7.9833L12.5283 4.18097C11.6457 3.49436 10.4097 3.49436 9.52709 4.18097L4.63759 7.9833C4.04212 8.44637 3.69398 9.15856 3.69434 9.91289V16.5129C3.69434 17.5254 4.51515 18.3462 5.52767 18.3462H16.5277C17.5402 18.3462 18.361 17.5254 18.361 16.5129V9.91289C18.361 9.15847 18.0127 8.44622 17.4168 7.9833",
    stroke: "#153230",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6668 13.7501C12.641 14.972 9.3575 14.972 7.3335 13.7501",
    stroke: "#153230",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlPanelIconHovered);
export default __webpack_public_path__ + "static/media/control_panel_icon_hovered.58c5f463bbc2e1f8677d1d63ed8950d6.svg";
export { ForwardRef as ReactComponent };